<template>

    <main class="gmp-page gmp-page--no-newsletter">

        <En_heroLanding />
        <En_highLights :clientWidth="clientWidth"/>
        <EnterpriseProduct :clientWidth="clientWidth"/>
        <div>Enterprise</div>
    </main>

</template>


<script>
    import En_heroLanding from "../../components/content/enterprise/index/En_heroLanding";
    import En_highLights from "../../components/content/enterprise/index/En_highLights";
    import EnterpriseProduct from "../../components/content/enterprise/index/EnterpriseProduct";


    export default {
        name: 'Enterprise',
        components: {
            En_heroLanding,
            En_highLights,
            // En_homeColorBar,
            EnterpriseProduct,
        },
        data() {
            return {
                clientWidth: "",
            }
        },

        mounted() {
            let that = this;
            this.clientWidth = `${document.documentElement.clientWidth}`          //document.body.clientWidth;
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.clientWidth = window.screenWidth
                })()
            }

        },
        methods: {

        }

    }
</script>

<style>


</style>
